
import { AssetPreviewTabInfoController } from './asset-preview-tab-info.controller'

function assetPreviewTabInfo () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-info/asset-preview-tab-info.html?$$REVISION$$',
    controller: AssetPreviewTabInfoController
  }
}
export { assetPreviewTabInfo }
